import { Schema as S } from "effect";

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const CreateScheduleResponseSchema = S.Array(S.String);

export type CreateScheduleResponse = S.Schema.Type<
  typeof CreateScheduleResponseSchema
>;
